import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LeadModel } from '../models/lead.model';
import { map, Observable } from 'rxjs';
import { LeadResponse } from '../interfaces/lead.response';
import { isPlatformBrowser } from '@angular/common';
//import { CreateleadResponse } from '../interfaces/createlead.response';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { EmailValidation } from '../interfaces/EmailValidation';
import { LeadLandingModel } from '../models/leadLanding.model';



declare let TrackJS: any;

@Injectable({
    providedIn: 'root'
})
export class LeadService {

    private lead: LeadModel;

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: any,
        private cookieService: SsrCookieService
    ) {
        this.lead = new LeadModel();
    }

    validateDuplicatedLead(email: string, mobileNumber: string) {
        const url = `${environment.api.base_url}${environment.api.paths.validateDuplicatedLead}`;
        const options = {
            params: new HttpParams()
                .set('email', email)
                .set('mobile_number', mobileNumber)
                .set('country', 'MX')
        };
        return this.http.get(url, options);
    }

    createLead(lead: LeadModel): Observable<LeadResponse> {

        if (isPlatformBrowser(this.platformId)) {
            TrackJS.configure({
                userId: lead.email + '_' + lead.mobile_number
            });
            TrackJS.track(`First lead post: ${JSON.stringify(lead)}`);
        }


        return this.http.post<LeadResponse>(`${environment.api.base_url}${environment.api.paths.createLead}`, lead)
            .pipe(
                map((res: any) => {
                    var obj = JSON.parse(res);
                    return (obj as LeadResponse);
                })
            );
    }

    updateLead(leadId: number, lead: LeadModel) {
        return this.http.put(`${environment.api.base_url}${environment.api.paths.createLead}/${leadId}`, lead);
    }

    getLead(): LeadModel {
        var lead = this.getCookie('lead');
        // run doble JSON.parse to fix parse error
        return lead !== '' ? JSON.parse(JSON.parse(lead)) : new LeadModel();
    }


    getLeadCurp(birthdate: string, born_state: string, first_name: string, last_name: string, second_last_name: string, gender: string) {
        const url = `${environment.api.base_url}${environment.api.paths.getCurp}`;
        const options = {
            params: new HttpParams()
                .set('birthdate', birthdate)
                .set('born_state', born_state)
                .set('first_name', first_name)
                .set('last_name', last_name)
                .set('second_last_name', second_last_name)
                .set('gender', gender)
        };
        return this.http.get(url, options);
    }


    apply(leadId: number, lead: LeadModel) {

        if (isPlatformBrowser(this.platformId)) {
            TrackJS.track(`Lead ${leadId} Apply: ${JSON.stringify(lead)}`);
        }

        const url = `${environment.api.base_url}${environment.api.paths.createLead}/${leadId}/apply`;
        return this.http.post(url, lead)
            .pipe(
                map((res: any) => {
                    // credilikeme
                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 9,
                    //             "name": "CREDILIKEME",
                    //             data: {
                    //                 status_code: 200,
                    //                 transaction_id: 'MjYxNzA5',
                    //                 redirect_to: "https://appmatic.credilike.me/calculator?apiPlayer=MjYxNzA5"
                    //             }
                    //         }
                    //     }
                    // }

                    // moneyman
                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lead_id": "12312333",
                    //         "partner_id": "87",
                    //         "status": "OK",
                    //         "redirect_url": "https://www.moneyman.com.mx/s/afadc96f",
                    //         "lender": {
                    //             "id": 9,
                    //             "name": "MONEYMAN"
                    //         }
                    //     }
                    // }

                    //lendon
                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "data": {
                    //             "ok": 1,
                    //             "customer-id": 55555,
                    //             "loan-id": 77777,
                    //             "forward-url": "https://www.creditone.sk/thanks"
                    //         },
                    //         "ok": 1,
                    //         "customer-id": 55555,
                    //         "loan-id": 77777,
                    //         "forward-url": "https://www.creditone.sk/thanks",
                    //         "lender": {
                    //             "id": 2,
                    //             "name": "LENDON"
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 37,
                    //             "name": "VIVUS_API",
                    //             "data": {
                    //                 "redirect_url": "https://dev.d11nqzk2ep57r4.amplifyapp.com/sso?token=211738529866dbc12a864d9e70e60e8c8cc12f71950895e49310af2ac099a0d1&client=1472914"
                    //             }
                    //         }
                    //     }
                    // }


                    // Vizne
                    //return { "status": "OK", "details": { "lender": { "id": 39, "name": "VIZNE_API", "data": { "redirect_url": "https://vizne.com.mx/formulario-4.jsp?tel=5516833062&cta=9000017867&asig=00018800132831" } } } }

                    // AVAFIN_CONSECUTIVE_LOAN_PLUS 
                    // return {
                    //     status: 'OK',
                    //     details: {
                    //         ok: 1,
                    //         data: {
                    //             'customer-id': 1306198,
                    //             'loan-id': 3340911,
                    //             'forward-url': 'https://www.avafin.mx/...'
                    //         },
                    //         lender: {
                    //             id: 45,
                    //             name: 'AVAFIN_CONSECUTIVE_LOAN_PLUS'
                    //         }
                    //     }
                    // }

                    // FINMERCADO
                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 50,
                    //             "name": "FINMERCADO_API",
                    //             "data": {
                    //                 "status": "OK",
                    //                 "leadId": "c5a5a02d-437b-4a84-bedc-d747fd2ff63d",
                    //                 "url": "https://app.finmercado.mx/offers?lead-id=c5a5a02d-437b-4a84-bedc-d747fd2ff63d&utm_source=publisher&utm_medium=api&utm_campaign=ojo-mx",
                    //                 "validationErrors": null,
                    //                 "errorMessage": null
                    //             }
                    //         }
                    //     }
                    // }
                    // SLANA
                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 52,
                    //             "name": "SLANA_API",
                    //             "data": {
                    //                 "clickId": "string",
                    //                 "isPreapproved": true,
                    //                 "redirectUrl": "https://slana.com/apply/abc123",
                    //                 "message": "Lead pre-approved by Slana",
                    //                 "webhookReceived": true
                    //             }
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 53,
                    //             "name": "SOLCREDITO_API",
                    //             "data": {
                    //                 "success": true,
                    //                 "references": {
                    //                     "redirect_url": "https://www.solcredito.mx/process/d907f9f5019d712f98bb7f80158a9b1522bbb956?campaign=&medium=&source=422168&xc=6f76340a6d596241704e9fa13eefdbeede0f7f0c",
                    //                     "embed_url": "https://www.solcredito.mx/process/d907f9f5019d712f98bb7f80158a9b1522bbb956/iframe?campaign=&medium=&source=422168&xc=6f76340a6d596241704e9fa13eefdbeede0f7f0c"
                    //                 }
                    //             }
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 54,
                    //             "name": "CREDITO365_API",
                    //             "data": {
                    //                 "message": "Lead successfully submitted to Credito365",
                    //                 "response": {
                    //                     "status": "accept",
                    //                     "code": null,
                    //                     "error": null
                    //                 },
                    //                 "subid1": "03_186437600_0c2c4fcf-abaa-4ad7-bdeb-fc16e6324367",
                    //                 "subid2": "credito365_1753223963765",
                    //                 "lead_id": 451,
                    //                 "lender_name": "CREDITO365_API",
                    //                 "redirect_url": "https://credito-365.mx/?utm_source=ojo7_api&utm_medium=affiliate&utm_campaign=ojo7_api&ClickID=07_222960324_b074a8ca-e528-425e-9b7e-98cc85a49550"
                    //             }
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 56,
                    //             "name": "MONEYCAT_API",
                    //             "data": {
                    //                 "status": "Success",
                    //                 "redirect_url": "https://www.google.com",
                    //                 "orderId": "58h4gffhgkdfg"
                    //             },
                    //             "redirectUrl": "https://www.google.com",
                    //             "orderId": "58h4gffhgkdfg"
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 57,
                    //             "name": "ABEA_API",
                    //             "data": {
                    //                 "token": "1234567890",
                    //                 "response": "OK",
                    //                 "timestamp": "2025-10-20T23:00:19.804Z",
                    //                 "redirectUrl": "https://onboarding.abea.mx/welcome.html?utm_source=ojo7afiliados&utm_medium=camp1&utm_campaign=06-25&utm_click_id=10_245080184_e1c8cacf-d190-4711-ada4-c46ba9fd2e57&token=1234567890"
                    //             }
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 58,
                    //             "name": "PROVIDENT_API",
                    //             "data": {
                    //                 "offer": {
                    //                     "offerId": 1234567890,
                    //                     "amount": 1000,
                    //                     "term": 30,
                    //                     "firstInstalment": 100,
                    //                     "weeklyPayment": 10
                    //                 }
                    //             },
                    //             "offerId": 1234567890
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 59,
                    //             "name": "WITME_API",
                    //             "data": {
                    //                 "servy_id": 34593462,
                    //                 "servy_status": "processed",
                    //                 "redirectUrl": "http://google.mx",
                    //                 "message": "Lead submitted successfully",
                    //                 "createdAt": "2025-12-26T23:16:39.000000Z",
                    //                 "timestamp": "2025-12-26T23:18:01.573Z"
                    //             }
                    //         }
                    //     }
                    // }

                    // return {
                    //     "status": "OK",
                    //     "details": {
                    //         "lender": {
                    //             "id": 60,
                    //             "name": "GODINERO_API",
                    //             "data": {
                    //                 "request_id": "fe8e6227-9ab9-47a3-b865-f3128219d9c1",
                    //                 "godinero_status": "accepted",
                    //                 "redirectUrl": "https://dev.godinero.mx/affiliate?request_id=fe8e6227-9ab9-47a3-b865-f3128219d9c1",
                    //                 "message": "Lead submitted successfully",
                    //                 "timestamp": "2026-02-17T23:26:21.786Z"
                    //             }
                    //         }
                    //     }
                    // }

                    if (isPlatformBrowser(this.platformId)) {
                        TrackJS.track(`Lead ${leadId}, lender response: ${JSON.stringify(res)}`);
                    }

                    return res;

                })
            )
    }

    // createLeadCrediclicLanding(lead: LeadLandingCrediclicModel) {
    //     return this.http.post(`${environment.api.base_url}${environment.api.paths.createCrediclicLandingLead}`, lead);
    // }

    providentAcceptOffer(obj: any) {
        return this.http.post(`${environment.api.base_url}${environment.api.paths.providentAcceptOffer}`, obj);
    }

    setLead(lead: LeadModel) {
        this.setCookie('lead', JSON.stringify(lead));
    }


    setLenderResult(lenderResult: any) {
        this.setCookie('result', JSON.stringify(lenderResult));
    }

    getLenderResult() {
        try {
            return JSON.parse(this.getCookie('result'));
        } catch (error) {
            return null;
        }

    }


    setpickupLenders(pickupLenders: any) {
        this.setCookie('pickup_lenders', JSON.stringify(pickupLenders));
    }

    getPickupLenders(): [] {
        var lenders = this.getCookie('pickup_lenders');
        if (lenders === '') {
            return [];
        } else {
            return JSON.parse(JSON.parse(lenders));
        }
    }

    // sendEmail(emailOpts: any) {
    //     const url = `${environment.api.base_url}${environment.api.paths.sendEmail}`;
    //     return this.http.post(url, emailOpts);
    // }

    clear() {
        if (isPlatformBrowser(this.platformId)) {
            console.log('reset');
            //this.cookieService.deleteAll('/', '', false, 'Strict');

            this.cookieService.delete('lead', '/', '', false, 'Strict');
            this.cookieService.delete('result', '/', '', false, 'Strict');
            this.cookieService.delete('pickup_lenders', '/', '', false, 'Strict');
            this.cookieService.delete('lid', '/', '', false, 'Strict');
        }
    }


    getCookie(key: string) {
        if (isPlatformBrowser(this.platformId)) {
            if (this.cookieService.check(key)) {
                return this.cookieService.get(key);
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    setCookie(key: string, obj: any) {
        if (isPlatformBrowser(this.platformId)) {
            this.cookieService.set(key, JSON.stringify(obj), { path: '/', expires: 7, sameSite: 'Strict' });
        }
    }

    setLeadId(leadId: number) {
        this.setCookie('lid', leadId);
    }

    getLeadId(): number {
        return parseInt(this.getCookie('lid') || '0');
    }

    applyMoneyman(leadId: number, sub_id: string, sid: string) {
        const url = `${environment.api.base_url}${environment.api.paths.moneyman_apply}/${leadId}`;
        return this.http.post(url, { sub_id: sub_id, sid: sid });
    }


    validateEmail(email: string): Observable<EmailValidation> {
        const url = `${environment.api.base_url}${environment.api.paths.validateEmail}`;
        const options = {
            params: new HttpParams()
                .set('email', email)
        };
        return this.http.get<EmailValidation>(url, options);
    }



    sendAvafinIneImages(leadId: number, fileFront: any, fileFrontContent: string, fileBack: any, fileBackContent: string, entryUrl: string) {

        if (isPlatformBrowser(this.platformId)) {
            TrackJS.track(`Lead ${leadId} avafin images process start`);
        }


        const url = `${environment.api.base_url}${environment.api.paths.createLead}/${leadId}/images`;

        var payload = {
            images: {
                front: {
                    "customer-id": "customer_id",
                    "document-name": "id-front-page",
                    "document-mime": fileFront.type,
                    "document-filename": fileFront.name,
                    "document-content": fileFrontContent.split(",")[1]
                },
                back: {
                    "customer-id": "customer_id",
                    "document-name": "id-back-page",
                    "document-mime": fileBack.type,
                    "document-filename": fileBack.name,
                    "document-content": fileBackContent.split(",")[1]
                }
            },
            entry_url: entryUrl
        }
        return this.http.post(url, payload);
    }



    createLandingsLead(lead: LeadLandingModel) {
        return this.http.post(`${environment.api.base_url}${environment.api.paths.createLandingsLead}`, lead);
    }


    updateShownInPingtree(kscrid: number) {
        return this.http.put(`${environment.api.base_url}${environment.api.paths.updateShownInPingtree}/${kscrid}`, {});
    }

}